module.exports = __webpack_public_path__ + "img/en-construccion-01.27e1b296.png";